// extracted by mini-css-extract-plugin
module.exports = {"buildControls":"BuildControls_buildControls__TOkxb","orderButton":"BuildControls_orderButton__2MmFK","enable":"BuildControls_enable__3iU6b"};